var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('SelectSupplierName',{model:{value:(_vm.inputedValue),callback:function ($$v) {_vm.inputedValue=$$v},expression:"inputedValue"}})],1),_c('v-col',{attrs:{"cols":"6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }